import comp from "./AssessmentToolsModal";
export default comp;
